import React, { useEffect } from 'react';

import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { SlLEContext } from '../../global-constants';
import { useEnterKeyPress } from '../../utils/useEnterKeyPress';
import { SlStreakCelebrationScreen } from '../../../../shared/public/SlStreakCelebrationScreen/SlStreakCelebrationScreen';
import { Container, StreakService } from '../../../../symphony';

export function StreakCelebration() {
	const { streak$, isFirstAchieve } = Container.take('global', StreakService);
	const { actions$ } = Container.take(SlLEContext, SlActions);

	useEffect(() => {
		actions$.next({
			type: ActionType.OnStreakCelebrationMount,
			requestType: RequestType.Parallel,
		});
	}, []);

	const onContinueCallback = () => {
		actions$.next({
			type: ActionType.OnStreakCelebrationScreenContinueClick,
			requestType: RequestType.Parallel,
		});
	};

	useEnterKeyPress(onContinueCallback);

	return streak$.value ? (
		<SlStreakCelebrationScreen
			streak={streak$.value}
			isFirstAchieve={isFirstAchieve()}
			onClick={onContinueCallback}
		/>
	) : null;
}
